import { useContext } from "react";
import { SupplierContext } from "./SuppliersPage";

/**
 * Retrieves the optional supplier context
 * @returns {Object} The supplier context.
 * @throws {Error} If the supplier context is not provided.
 */
const useOptionalSupplierContext = () => {
  try {
    const context = useContext(SupplierContext);
    if (context === undefined) {
      throw new Error("SupplierContext not provided");
    }
    return context;
  } catch (e) {
    return {
      suppliers: [],
      setSuppliers: () => {},
    };
  }
};

export default useOptionalSupplierContext;
